import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Paper, Title, Group, Stack, Button } from "@mantine/core";
import { PageLoader } from "@/components/common";
import { FilterList } from "@/components/filters";
import { filtersApi } from "@/api/client";

export const Route = createFileRoute("/_authenticated/filters/")({
  component: FiltersPage,
});

function FiltersPage() {
  const { data: filters, isLoading } = useQuery({
    queryKey: ["filters"],
    queryFn: filtersApi.list,
  });

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <Stack gap="md">
      <Group justify="space-between">
        <Title order={1}>Filters</Title>
        <Button component={Link} to="/filters/new">
          Create Filter
        </Button>
      </Group>

      <Paper p="md" radius="md" withBorder style={{ borderColor: "#0f3460" }}>
        <FilterList filters={filters || []} />
      </Paper>
    </Stack>
  );
}
